// import React, { useState, useEffect } from "react";
// import { FaRegSmileBeam } from "react-icons/fa";
// import { useNavigate } from "react-router-dom";
// import axios from "../../api/axiosInstance";
// import toast, { Toaster } from "react-hot-toast";

// const RegisterStep6 = () => {
//   const navigate = useNavigate();

//   const [about, setAbout] = useState("");
//   const [photo, setPhoto] = useState(null);
//   const [photoPreview, setPhotoPreview] = useState(null);
//   const [loading, setLoading] = useState(false);
//   const [allData, setAllData] = useState({});
//   const [showReview, setShowReview] = useState(false);
//   const [errors, setErrors] = useState({});

//   useEffect(() => {
//     const savedData =
//       JSON.parse(localStorage.getItem("registrationData")) || {};
//     setAllData(savedData);
//     if (savedData.about) setAbout(savedData.about);
//     if (savedData.photoPreview) setPhotoPreview(savedData.photoPreview);
//   }, []);

//   const handlePhotoChange = (e) => {
//     const file = e.target.files[0];
//     setPhoto(file);
//     if (file) {
//       const reader = new FileReader();
//       reader.onloadend = () => {
//         setPhotoPreview(reader.result);

//         // Save preview in localStorage
//         const updatedData = { ...allData, photoPreview: reader.result };
//         setAllData(updatedData);
//         localStorage.setItem("registrationData", JSON.stringify(updatedData));
//       };
//       reader.readAsDataURL(file);
//     } else {
//       setPhotoPreview(null);
//       const updatedData = { ...allData, photoPreview: null };
//       setAllData(updatedData);
//       localStorage.setItem("registrationData", JSON.stringify(updatedData));
//     }
//   };

//   const handleFinalSubmit = async () => {
//     setLoading(true);

//     try {
//       const camelToSnake = (str) =>
//         str.replace(/[A-Z]/g, (letter) => `_${letter.toLowerCase()}`);

//       const formData = new FormData();

//       Object.entries(allData).forEach(([key, value]) => {
//         if (key !== "photoPreview") {
//           formData.append(camelToSnake(key), value);
//         }
//       });

//       formData.append("about", about);
//       if (photo) {
//         formData.append("photo", photo);
//       }

//       await axios.post("/api/complete-registration/", formData, {
//         headers: { "Content-Type": "multipart/form-data" },
//       });

//       toast.success("Registration successful! Please login.");
//       localStorage.removeItem("registrationData");
//       navigate("/membership-pricing");
//     } catch (error) {
//       console.error("Registration error:", error.response?.data || error);

//       // Extract DRF field-level errors (like { "email": ["This field is required."] })
//       const data = error.response?.data;

//       if (data && typeof data === "object" && !Array.isArray(data)) {
//         // Loop through all error fields
//         Object.entries(data).forEach(([field, messages]) => {
//           if (Array.isArray(messages)) {
//             toast.error(`${field}: ${messages.join(", ")}`);
//           } else {
//             toast.error(`${field}: ${messages}`);
//           }
//         });
//       } else {
//         toast.error(
//           "Registration failed: " +
//             (data?.error ||
//               data?.detail ||
//               "Please check your details and try again.")
//         );
//       }
//     } finally {
//       setLoading(false);
//       setShowReview(false);
//     }
//   };

//   const handleSubmit = (e) => {
//     e.preventDefault();
//     let newErrors = {};

//     if (!about.trim()) {
//       newErrors.about = "Please write about yourself.";
//     } else if (about.trim().length < 50) {
//       newErrors.about = "Please write at least 50 characters.";
//     }

//     if (photo && !photo.type.startsWith("image/")) {
//       newErrors.photo = "Only image files are allowed.";
//     }

//     if (Object.keys(newErrors).length > 0) {
//       setErrors(newErrors);

//       // Scroll to the first error
//       const firstErrorField = document.querySelector(
//         `[name="${Object.keys(newErrors)[0]}"]`
//       );
//       if (firstErrorField)
//         firstErrorField.scrollIntoView({ behavior: "smooth", block: "center" });

//       return;
//     }

//     setErrors({});
//     const updatedData = { ...allData, about };
//     setAllData(updatedData);
//     localStorage.setItem("registrationData", JSON.stringify(updatedData));
//     setShowReview(true);
//   };

//   const handleBack = () => {
//     // Save current data before navigating back
//     const updatedData = { ...allData, about };
//     localStorage.setItem("registrationData", JSON.stringify(updatedData));
//     navigate("/register-step5-html"); // adjust to your step 5 route
//   };

//   return (
//     <div className="min-h-screen flex items-center justify-center bg-gray-50 p-4 relative">
//       <Toaster position="top-center" reverseOrder={false} />

//       <div className="bg-white shadow-lg rounded-2xl flex flex-col md:flex-row w-full max-w-3xl overflow-hidden">
//         {/* Left Section */}
//         <div className="md:w-1/2 bg-yellow-50 flex flex-col justify-center items-center p-8">
//           <FaRegSmileBeam className="text-yellow-600 text-7xl mb-6" />
//           <p className="text-xl md:text-2xl font-semibold text-yellow-700 text-center">
//             Let's write something interesting about you
//           </p>
//         </div>

//         {/* Right Section */}
//         <div className="md:w-1/2 w-full p-8">
//           <h2 className="text-2xl md:text-3xl font-semibold text-gray-800 mb-1">
//             About You
//           </h2>
//           <p className="text-sm text-gray-500 mb-4">
//             Write a few lines describing yourself, your family, or your values
//             to attract relevant matches.
//           </p>

//           <form onSubmit={handleSubmit} className="space-y-4 mt-4">
//             {/* About */}
//             <div>
//               <textarea
//                 name="about"
//                 value={about}
//                 onChange={(e) => setAbout(e.target.value)}
//                 placeholder="I am self-employed, currently living in Indore..."
//                 rows={6}
//                 className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-yellow-400 resize-none"
//                 maxLength={1000}
//                 required
//               ></textarea>
//               <p className="text-xs text-gray-400 text-right mt-1">
//                 {about.length} Characters Typed.
//               </p>
//               {errors.about && (
//                 <p className="text-sm text-red-500 mt-1">{errors.about}</p>
//               )}
//             </div>

//             {/* Profile Photo */}
//             <div>
//               <label className="block text-gray-700 mb-1">
//                 Upload Profile Photo
//               </label>
//               <input
//                 type="file"
//                 accept="image/*"
//                 onChange={handlePhotoChange}
//                 className="w-full border border-gray-300 rounded-lg px-3 py-2"
//               />
//               {errors.photo && (
//                 <p className="text-sm text-red-500 mt-1">{errors.photo}</p>
//               )}

//               {photoPreview && (
//                 <img
//                   src={photoPreview}
//                   alt="Preview"
//                   className="mt-2 rounded-lg shadow w-32 h-32 object-cover"
//                 />
//               )}
//             </div>

//             <div className="flex gap-3">
//               <button
//                 type="button"
//                 onClick={handleBack}
//                 className="flex-1 bg-gray-300 hover:bg-gray-400 text-gray-800 font-semibold py-2 rounded-lg transition duration-200"
//               >
//                 Back
//               </button>

//               <button
//                 type="submit"
//                 disabled={loading}
//                 className="flex-1 bg-orange-500 hover:bg-orange-600 text-white font-semibold py-2 rounded-lg transition duration-200"
//               >
//                 {loading ? "Submitting..." : " Submit"}
//               </button>
//             </div>
//           </form>

//           <p className="text-xs text-center text-gray-400 mt-6">
//             Copyright © 2025. All rights reserved.
//           </p>
//         </div>
//       </div>

//       {/* Summary Modal */}
//       {showReview && (
//         <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50 p-4">
//           <div className="bg-white rounded-lg shadow-lg max-w-lg w-full p-6 overflow-y-auto max-h-[90vh]">
//             <h3 className="text-xl font-semibold mb-4 text-center text-gray-800">
//               Review Your Details Before Submission
//             </h3>
//             <div className="space-y-2 text-sm text-gray-700">
//               {Object.entries(allData).map(([key, value]) => {
//                 if (key === "photoPreview") return null;
//                 return (
//                   <div key={key}>
//                     <strong className="capitalize">
//                       {key.replace(/([A-Z])/g, " $1")}:
//                     </strong>{" "}
//                     {value ? String(value) : "N/A"}
//                   </div>
//                 );
//               })}
//               <div>
//                 <strong>About:</strong> {about}
//               </div>
//               {photoPreview && (
//                 <div className="mt-2">
//                   <strong>Profile Photo:</strong>
//                   <img
//                     src={photoPreview}
//                     alt="Preview"
//                     className="mt-1 rounded-lg w-32 h-32 object-cover"
//                   />
//                 </div>
//               )}
//             </div>
//             <div className="flex gap-3 mt-4">
//               <button
//                 onClick={() => setShowReview(false)}
//                 className="flex-1 bg-gray-300 hover:bg-gray-400 text-gray-800 py-2 rounded-lg"
//               >
//                 Edit
//               </button>
//               <button
//                 onClick={handleFinalSubmit}
//                 disabled={loading}
//                 className="flex-1 bg-green-500 hover:bg-green-600 text-white py-2 rounded-lg"
//               >
//                 {loading ? "Submitting..." : "Confirm & Submit"}
//               </button>
//             </div>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default RegisterStep6;

import React, { useState, useEffect } from "react";
import {
  FaRegSmileBeam,
  FaCloudUploadAlt,
  FaTimes,
  FaArrowLeft,
} from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import axios from "../../api/axiosInstance";
import toast, { Toaster } from "react-hot-toast";

const TOTAL_STEPS = 6;
const CURRENT_STEP = 6;

const RegisterStep6 = () => {
  const navigate = useNavigate();

  const [about, setAbout] = useState("");
  const [photo, setPhoto] = useState(null);
  const [photoPreview, setPhotoPreview] = useState(null);
  const [loading, setLoading] = useState(false);
  const [allData, setAllData] = useState({});
  const [showReview, setShowReview] = useState(false);
  const [errors, setErrors] = useState({});
  const [dragActive, setDragActive] = useState(false);

  useEffect(() => {
    const savedData =
      JSON.parse(localStorage.getItem("registrationData")) || {};
    setAllData(savedData);
    if (savedData.about) setAbout(savedData.about);
    if (savedData.photoPreview) setPhotoPreview(savedData.photoPreview);
  }, []);

  const processPhotoFile = (file) => {
    if (!file) {
      removePhoto();
      return;
    }

    if (!file.type.startsWith("image/")) {
      setErrors((prev) => ({
        ...prev,
        photo: "Only image files are allowed.",
      }));
      return;
    }

    if (file.size > 5 * 1024 * 1024) {
      setErrors((prev) => ({ ...prev, photo: "Image must be under 5MB." }));
      return;
    }

    setErrors((prev) => ({ ...prev, photo: null }));
    setPhoto(file);

    const reader = new FileReader();
    reader.onloadend = () => {
      setPhotoPreview(reader.result);
      const updatedData = { ...allData, photoPreview: reader.result };
      setAllData(updatedData);
      localStorage.setItem("registrationData", JSON.stringify(updatedData));
    };
    reader.readAsDataURL(file);
  };

  const handlePhotoChange = (e) => {
    processPhotoFile(e.target.files[0]);
  };

  const handleDrop = (e) => {
    e.preventDefault();
    setDragActive(false);
    processPhotoFile(e.dataTransfer.files?.[0]);
  };

  const handleDragOver = (e) => {
    e.preventDefault();
    setDragActive(true);
  };

  const handleDragLeave = (e) => {
    e.preventDefault();
    setDragActive(false);
  };

  const removePhoto = () => {
    setPhoto(null);
    setPhotoPreview(null);
    const updatedData = { ...allData, photoPreview: null };
    setAllData(updatedData);
    localStorage.setItem("registrationData", JSON.stringify(updatedData));
  };

  const handleFinalSubmit = async () => {
    setLoading(true);
    try {
      const camelToSnake = (str) =>
        str.replace(/[A-Z]/g, (letter) => `_${letter.toLowerCase()}`);

      const formData = new FormData();
      Object.entries(allData).forEach(([key, value]) => {
        if (key !== "photoPreview") {
          formData.append(camelToSnake(key), value);
        }
      });

      formData.append("about", about);
      if (photo) {
        formData.append("photo", photo);
      }

      await axios.post("/api/complete-registration/", formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });

      toast.success("Registration successful! Please login.");
      localStorage.removeItem("registrationData");
      navigate("/membership-pricing");
    } catch (error) {
      console.error("Registration error:", error.response?.data || error);
      const data = error.response?.data;

      if (data && typeof data === "object" && !Array.isArray(data)) {
        Object.entries(data).forEach(([field, messages]) => {
          if (Array.isArray(messages)) {
            toast.error(`${field}: ${messages.join(", ")}`);
          } else {
            toast.error(`${field}: ${messages}`);
          }
        });
      } else {
        toast.error(
          "Registration failed: " +
            (data?.error ||
              data?.detail ||
              "Please check details and try again."),
        );
      }
    } finally {
      setLoading(false);
      setShowReview(false);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    let newErrors = {};

    if (!about.trim()) {
      newErrors.about = "Please write about yourself.";
    } else if (about.trim().length < 50) {
      newErrors.about = "Please write at least 50 characters.";
    }

    if (photo && !photo.type.startsWith("image/")) {
      newErrors.photo = "Only image files are allowed.";
    }

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      const firstErrorField = document.querySelector(
        `[name="${Object.keys(newErrors)[0]}"]`,
      );
      if (firstErrorField)
        firstErrorField.scrollIntoView({ behavior: "smooth", block: "center" });
      return;
    }

    setErrors({});
    const updatedData = { ...allData, about };
    setAllData(updatedData);
    localStorage.setItem("registrationData", JSON.stringify(updatedData));
    setShowReview(true);
  };

  const handleBack = () => {
    const updatedData = { ...allData, about };
    localStorage.setItem("registrationData", JSON.stringify(updatedData));
    navigate("/register-step5-html");
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-50 px-3 py-5 sm:p-6 md:p-8 font-sans antialiased selection:bg-indigo-500 selection:text-white">
      <Toaster position="top-center" reverseOrder={false} />

      <div className="bg-white shadow-2xl rounded-2xl sm:rounded-3xl flex flex-col md:flex-row w-full max-w-5xl overflow-hidden md:min-h-[600px] border border-slate-100">
        {/* Hero panel — desktop / tablet only, hidden on phones to save vertical space */}
        <div className="hidden md:flex md:w-5/12 bg-gradient-to-tr from-indigo-600 via-indigo-700 to-violet-800 flex-col justify-between p-8 text-white relative overflow-hidden">
          <div className="absolute -top-10 -right-10 w-40 h-40 bg-white/10 rounded-full blur-2xl pointer-events-none" />
          <div className="absolute -bottom-10 -left-10 w-52 h-52 bg-indigo-500/20 rounded-full blur-3xl pointer-events-none" />

          <div className="flex items-center gap-2">
            <span className="h-2.5 w-2.5 rounded-full bg-emerald-400 animate-pulse" />
            <span className="text-xs uppercase tracking-widest text-indigo-200 font-bold">
              Final Step
            </span>
          </div>

          <div className="flex flex-col items-start my-auto py-8">
            <div className="p-4 bg-white/10 backdrop-blur-md rounded-2xl mb-6 shadow-inner">
              <FaRegSmileBeam className="text-white text-5xl lg:text-6xl" />
            </div>
            <h1 className="text-2xl lg:text-3xl font-bold leading-tight tracking-tight">
              Let's write something interesting about you.
            </h1>
            <p className="text-indigo-100/80 text-sm mt-3">
              Your profile snapshot determines your first impression. Let your
              authentic personality shine!
            </p>
          </div>

          <div className="flex gap-2">
            {Array.from({ length: TOTAL_STEPS }, (_, i) => i + 1).map(
              (step) => (
                <span
                  key={step}
                  className={`h-1.5 rounded-full transition-all duration-300 ${
                    step === CURRENT_STEP ? "w-8 bg-white" : "w-2 bg-white/40"
                  }`}
                />
              ),
            )}
          </div>
        </div>

        {/* Form panel */}
        <div className="md:w-7/12 w-full flex flex-col bg-white">
          {/* Compact header — phones only */}
          <div className="flex md:hidden items-center justify-between px-5 pt-5 pb-4 border-b border-slate-100">
            <button
              type="button"
              onClick={handleBack}
              aria-label="Go back to previous step"
              className="p-2 -ml-2 rounded-full text-slate-500 hover:bg-slate-100 active:bg-slate-200 transition-colors"
            >
              <FaArrowLeft className="text-sm" />
            </button>
            <div className="flex items-center gap-1.5">
              {Array.from({ length: TOTAL_STEPS }, (_, i) => i + 1).map(
                (step) => (
                  <span
                    key={step}
                    className={`h-1.5 rounded-full transition-all duration-300 ${
                      step === CURRENT_STEP
                        ? "w-6 bg-indigo-600"
                        : "w-1.5 bg-slate-200"
                    }`}
                  />
                ),
              )}
            </div>
            <span className="text-[11px] font-bold text-indigo-600 bg-indigo-50 px-2.5 py-1 rounded-full">
              {CURRENT_STEP}/{TOTAL_STEPS}
            </span>
          </div>

          <div className="flex-1 p-5 sm:p-8 md:p-12">
            <div className="hidden md:flex items-center justify-between border-b border-slate-100 pb-5 mb-6">
              <div>
                <h2 className="text-2xl font-bold text-slate-800">About You</h2>
                <p className="text-xs text-slate-400 mt-0.5">
                  Step {CURRENT_STEP} of {TOTAL_STEPS}: Identity Setup
                </p>
              </div>
            </div>

            <div className="md:hidden mb-5">
              <h2 className="text-xl font-bold text-slate-800 flex items-center gap-2">
                <FaRegSmileBeam className="text-indigo-500" />
                About You
              </h2>
            </div>

            <p className="text-sm text-slate-500 leading-relaxed mb-6">
              Write a few lines describing yourself, your family background,
              career ambitions, or values to attract matches aligned with your
              lifestyle.
            </p>

            <form onSubmit={handleSubmit} className="space-y-6">
              {/* About */}
              <div>
                <label className="block text-xs font-bold text-slate-700 tracking-wide uppercase mb-2">
                  Bio / Overview <span className="text-red-500">*</span>
                </label>
                <textarea
                  name="about"
                  value={about}
                  onChange={(e) => setAbout(e.target.value)}
                  placeholder="I am self-employed, currently living in Indore. Modern outlook with a deep respect for core values..."
                  rows={5}
                  aria-invalid={Boolean(errors.about)}
                  aria-describedby={errors.about ? "about-error" : undefined}
                  className={`w-full border rounded-xl px-4 py-3 text-sm text-slate-800 placeholder-slate-400 transition-all focus:outline-none focus:ring-4 ${
                    errors.about
                      ? "border-red-400 focus:ring-red-100 focus:border-red-500"
                      : "border-slate-200 focus:ring-indigo-100 focus:border-indigo-500"
                  } resize-none`}
                  maxLength={1000}
                  required
                ></textarea>

                <div className="flex flex-wrap items-center justify-between gap-2 mt-1.5 px-1">
                  <p
                    id="about-error"
                    className={`text-xs font-medium text-red-500 ${errors.about ? "" : "sr-only"}`}
                  >
                    {errors.about || "placeholder"}
                  </p>
                  <span
                    className={`text-[11px] font-semibold px-2 py-0.5 rounded-full whitespace-nowrap ${
                      about.length < 50
                        ? "bg-amber-50 text-amber-600"
                        : "bg-slate-100 text-slate-500"
                    }`}
                  >
                    {about.length} / 1000 {about.length < 50 && "(min 50)"}
                  </span>
                </div>
              </div>

              {/* Photo upload */}
              <div>
                <label className="block text-xs font-bold text-slate-700 tracking-wide uppercase mb-2">
                  Profile Photograph
                </label>

                {!photoPreview ? (
                  <label
                    onDrop={handleDrop}
                    onDragOver={handleDragOver}
                    onDragLeave={handleDragLeave}
                    className={`flex flex-col items-center justify-center border-2 border-dashed rounded-xl p-5 sm:p-6 transition-all cursor-pointer bg-slate-50 hover:bg-slate-100/70 group ${
                      errors.photo
                        ? "border-red-300"
                        : dragActive
                          ? "border-indigo-500 bg-indigo-50/50"
                          : "border-slate-200 hover:border-indigo-400"
                    }`}
                  >
                    <FaCloudUploadAlt className="text-3xl text-slate-400 group-hover:text-indigo-500 transition-colors mb-2" />
                    <span className="text-xs font-semibold text-slate-600 text-center">
                      Tap to upload
                      <span className="hidden sm:inline">
                        {" "}
                        or drag &amp; drop
                      </span>
                    </span>
                    <span className="text-[11px] text-slate-400 mt-1">
                      PNG, JPG or JPEG up to 5MB
                    </span>
                    <input
                      type="file"
                      accept="image/*"
                      onChange={handlePhotoChange}
                      className="hidden"
                    />
                  </label>
                ) : (
                  <div className="relative inline-block mt-1">
                    <img
                      src={photoPreview}
                      alt="Profile preview"
                      className="rounded-2xl shadow-md w-28 h-28 sm:w-32 sm:h-32 object-cover border-2 border-indigo-500/20"
                    />
                    <button
                      type="button"
                      onClick={removePhoto}
                      aria-label="Remove photo"
                      className="absolute -top-2 -right-2 p-1.5 bg-rose-500 hover:bg-rose-600 text-white rounded-full shadow-lg transition-transform hover:scale-110"
                    >
                      <FaTimes className="text-xs" />
                    </button>
                  </div>
                )}

                {errors.photo && (
                  <p className="text-xs font-medium text-red-500 mt-1.5 px-1">
                    {errors.photo}
                  </p>
                )}
              </div>

              {/* Actions */}
              <div className="flex gap-3 sm:gap-4 pt-4 border-t border-slate-100">
                <button
                  type="button"
                  onClick={handleBack}
                  className="hidden sm:flex flex-1 bg-slate-100 hover:bg-slate-200 text-slate-700 font-bold py-3 px-4 rounded-xl transition duration-200 text-sm tracking-wide justify-center focus:outline-none focus-visible:ring-4 focus-visible:ring-slate-200"
                >
                  Back
                </button>

                <button
                  type="submit"
                  disabled={loading}
                  className="flex-1 bg-indigo-600 hover:bg-indigo-700 text-white font-bold py-3 px-4 rounded-xl transition duration-200 text-sm tracking-wide shadow-lg shadow-indigo-600/20 disabled:opacity-50 disabled:cursor-not-allowed focus:outline-none focus-visible:ring-4 focus-visible:ring-indigo-100"
                >
                  {loading ? "Processing..." : "Review & Submit"}
                </button>
              </div>
            </form>
          </div>

          <p className="text-[11px] text-center text-slate-400 pb-6 px-5">
            Copyright © 2026. Secured Profile Network Cloud Systems.
          </p>
        </div>
      </div>

      {/* Review modal — bottom sheet on phones, centered dialog from sm breakpoint up */}
      {showReview && (
        <div
          role="dialog"
          aria-modal="true"
          aria-labelledby="review-heading"
          className="fixed inset-0 bg-slate-900/60 backdrop-blur-sm flex items-end sm:items-center justify-center z-50 sm:p-4 animate-fadeIn"
        >
          <div className="bg-white w-full sm:max-w-lg rounded-t-3xl sm:rounded-2xl shadow-2xl overflow-hidden flex flex-col max-h-[88vh] sm:max-h-[90vh]">
            <div className="p-5 sm:p-6 border-b border-slate-100 bg-slate-50 flex items-start justify-between gap-3">
              <div>
                <h3
                  id="review-heading"
                  className="text-lg font-bold text-slate-800"
                >
                  Review Profile Summary
                </h3>
                <p className="text-xs text-slate-500">
                  Confirm everything is accurate before saving.
                </p>
              </div>
              <button
                type="button"
                onClick={() => setShowReview(false)}
                aria-label="Close review"
                className="sm:hidden p-2 -mr-2 -mt-1 rounded-full text-slate-400 hover:bg-slate-100"
              >
                <FaTimes />
              </button>
            </div>

            <div className="p-5 sm:p-6 overflow-y-auto space-y-4 text-sm text-slate-700">
              {Object.entries(allData).map(([key, value]) => {
                if (key === "photoPreview" || !value) return null;
                return (
                  <div
                    key={key}
                    className="flex justify-between items-start gap-4 py-1.5 border-b border-slate-50 last:border-0"
                  >
                    <strong className="capitalize text-slate-500 font-semibold min-w-[110px] shrink-0">
                      {key.replace(/([A-Z])/g, " $1")}:
                    </strong>
                    <span className="text-slate-800 font-medium text-right break-all">
                      {String(value)}
                    </span>
                  </div>
                );
              })}

              <div className="pt-2">
                <strong className="block text-slate-500 font-semibold mb-1">
                  About Bio Statement:
                </strong>
                <p className="text-slate-800 bg-slate-50 rounded-xl p-3 text-xs leading-relaxed border border-slate-100">
                  {about}
                </p>
              </div>

              {photoPreview && (
                <div className="pt-2 flex items-center gap-4">
                  <div>
                    <strong className="block text-slate-500 font-semibold">
                      Profile Photo Attachment:
                    </strong>
                    <span className="text-[11px] text-slate-400">
                      Successfully attached
                    </span>
                  </div>
                  <img
                    src={photoPreview}
                    alt="Final profile preview"
                    className="rounded-xl w-16 h-16 object-cover border border-slate-200 ml-auto shadow-sm"
                  />
                </div>
              )}
            </div>

            <div className="p-4 bg-slate-50 border-t border-slate-100 flex gap-3 pb-[calc(1rem+env(safe-area-inset-bottom))]">
              <button
                onClick={() => setShowReview(false)}
                className="flex-1 bg-white hover:bg-slate-100 text-slate-700 border border-slate-200 font-bold py-2.5 rounded-xl text-xs transition duration-150 focus:outline-none focus-visible:ring-4 focus-visible:ring-slate-100"
              >
                Go Back &amp; Edit
              </button>
              <button
                onClick={handleFinalSubmit}
                disabled={loading}
                className="flex-1 bg-emerald-600 hover:bg-emerald-700 text-white font-bold py-2.5 rounded-xl text-xs shadow-lg shadow-emerald-600/10 transition duration-150 disabled:opacity-50 focus:outline-none focus-visible:ring-4 focus-visible:ring-emerald-100"
              >
                {loading ? "Submitting Registration..." : "Confirm & Complete"}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default RegisterStep6;
